import { RootState } from '@app/redux/root-reducer';

export const selectCollectionState = (store: RootState) => store.collectionReducer.collection;
export const selectAddCollectionState = (store: RootState) => store.collectionReducer.addCollection;
export const selectUpdateCollectionStatus = (store: RootState) =>
  store.collectionReducer.updateCollectionStatus;
export const selectDeleteCollectionState = (store: RootState) =>
  store.collectionReducer.deleteCollection;
